<template>
    <div class="plan-content mb-30">
        <p>This will submit a request to the NBF Retirement services to run and email you a Pension Credits History Report. The report will be sent to your registered email address  {{ userEmail }} within 24–48 hours. Click the Submit button to confirm.</p>
        <form v-if="userName" @submit.prevent="handleSubmit" @keypress.enter="handleSubmit" class="form update-address align-items-start mt-20" method="post">
            <div class="w-100 inputs-wrapper mb-20 d-flex flex-wrap gap-20">
                <TextInput type="text" label="Full Name" placeholder="Enter Full Name" :max=50 :readonly="true"
                    v-model:modelValue="formData.FullName" :error="errors?.FullName" :isRequired="true" />
                <TextInput type="email" label="Email Address" placeholder="Enter Email Address" :max=50 :readonly="true"
                    v-model:modelValue="formData.Email" :isRequired="true" :error="errors?.Email"/>
                <div class="d-flex align-items-end gap-15 mt-20 ms-auto">
                    <button type="button" class="btn btn-secondary" @click="handleCancel">Cancel</button>
                    <button type="submit" class="btn btn-primary">{{ loadingSubmit ? 'Submitting...' : 'Submit'}}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref, type Ref } from 'vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useModalStore } from '@/stores/modal';
import TextInput from '@components/form/TextInput.vue';

interface FormData {
    FullName: string;
    Email: string;
    PersonID: number;
}

interface ErrorFormData {
    FullName: string | null;
    Email: string | null;
}

const authStore = useAuthStore();
const modalStore = useModalStore();

const userName = computed(() => authStore.userName);
const userEmail = computed(() => authStore.userEmail);
const participantId = computed<number>(() => authStore?.user?.participantId ?? 0);

const formData: FormData = reactive({
    FullName: userName.value ?? '',
    Email: userEmail.value ?? '',
    PersonID: participantId.value,
});

const route = 'api/participant/pch-request';
const loadingSubmit = ref(false);
const success = ref<string | null>(null);
const errors: Ref<Partial<ErrorFormData>> = ref({});

const handleCancel = () => modalStore.closeLastModal()

// Send Email
const handleSubmit = async () => {
    if (loadingSubmit.value) return;

    loadingSubmit.value = true;
    errors.value = {};

    try {
        const response = await axios.post(route, { ...formData });
        success.value = response.data?.success ?? null;

        if (success.value) {
            modalStore.openModal('success-modal', null, 'modal-success', null, {
                title: 'Pension Credits History Report',
                content: {
                    type: 'text',
                    value: success.value,
                },
            });
        }
    } catch (error: any) {
        if (error.response) {
            errors.value = error.response.data.errors ?? {};
        }
    } finally {
        loadingSubmit.value = false;
    }
};
</script>